const translation = {
	common: {
		addToList: "Add to list",
		confirmAction: "Confirm action!",
		confirmed: "Confirmed",
		done: "Done",
		save: "Save",
		cancel: "Cancel",
	},
	validation: {
		required: "This field is required",
	},
	months: {
		january: "January",
		february: "February",
		march: "March",
		april: "April",
		may: "May",
		june: "June",
		july: "July",
		august: "August",
		september: "September",
		october: "October",
		november: "November",
		december: "December",
	},
	banners: {
		addBanner: "Add banner",
		addLargeBanner: "Add large banner",
		bannerLink: "Banner link",
		confirmDelete: "Do you want to delete the banner?",
		confirmSaveBanners: "Do you confirm saving the banners?",
		confirmSaveChanges: "Do you confirm saving the changes?",
		confirmSaveText: "Confirm text saving",
		description: "Description",
		displayBanner: "Display banner",
		editBanner: "Edit banner",
		imageAlt: "Select image",
		noBanners: "No banners yet",
		photoDeleted: "Photo {{name}} has been deleted!",
		recommendedLargeSize:
			"Recommended banner photo size is 1600x600 (file extensions: jpg, jpeg, png)",
		title: "Title",
		errors: {
			invalidUploadData: "Invalid login or image name data",
			largeFileName: "The selected image name is too long",
			maxFileSize: "Photo size must be no more than 0.5 MB",
			maxResolution: "Maximum image resolution is 1920px x 1280px",
			requiredBanner: "Banner upload is required",
			requiredTwoBanners: "Two banners must be uploaded",
			supportedTypes: "Supported image extensions: jpg, jpeg, png",
			uploadImage: "Image upload error",
		},
		placeholders: {
			description: "Enter banner description",
			title: "Enter banner title",
		},
	},
	discountProducts: {
		categoriesTitle: "Categories excluded from discounts",
		confirmSave: "Do you confirm saving categories and products?",
		duplicateId: "This ID is already in the list",
		emptyField: "Empty field",
		productsTitle: "Products excluded from discounts",
		placeholders: {
			categoryId: "Enter category ID",
			productId: "Enter product ID",
		},
	},
	discounts: {
		deliveryOrder: "For delivery",
		discounts: "Discounts",
		firstOrder: "First order",
		loyaltySystem: "Loyalty system",
		pickupOrder: "For pickup",
		sales: "Promotions",
		tabs: {
			banners: "Banners",
			discounts: "Discounts",
			promocodes: "Promo codes",
			sales: "Promotions",
		},
		form: {
			amount: "Amount",
			amountDiscount: "Discount amount",
			amountDiscountPlaceholder: "Enter discount amount",
			confirmSaveChanges: "Do you confirm saving the changes?",
			discount: "Discount",
			discountPercent: "Discount percent",
			discountPercentPlaceholder: "Enter discount percent",
			integerOnly: "Integers only",
			maxPercent: "Value must be less than or equal to {count}",
			orderAmount: "Enter order amount",
			present: "Gift",
			productId: "Product ID",
			productIdPlaceholder: "Enter product ID",
			required: "This field is required",
		},
	},
	promocodes: {
		add: "Add",
		apply: "Apply",
		applyForDiscountProducts: "Apply to promotional products",
		calendarPeriod: "Select period:",
		categoriesExcluded: "Categories the promo code does not apply to",
		categoriesExcludedHint: "List of categories the promo code does not apply to",
		code: "Promo code",
		codePlaceholder: "Enter promo code",
		confirmDelete: "Do you confirm deleting {{id}}?",
		create: "Create promo code",
		description: "Description",
		descriptionPlaceholder: "Enter promo description",
		discountSystemId: "Discount ID from accounting system",
		discountSystemIdNote:
			"Fill in only if you are sure the ID is correct (iiko example 0a124f13-99b2-41df-b286-4f21e41c4717, poster example 4)",
		duplicateId: "This ID is already in the list",
		edit: "Edit promo code",
		emptyField: "Empty field",
		invalidData: "Invalid data",
		latinOnly: "Latin letters only",
		minOrderAmount: "Minimum order amount",
		minOrderAmountHint:
			"Minimum order amount for using the promo code. If there is none, enter 0",
		minOrderAmountPlaceholder: "Enter minimum amount or 0",
		noPromocodes: "No promo codes yet",
		productsExcluded: "Products the promo code does not apply to",
		productsExcludedHint: "List of products the promo code does not apply to",
		title: "Promo codes",
		titleField: "Name",
		titlePlaceholder: "Enter promo name",
	},
	categoryForPickup: {
		categoriesTitle: "Categories",
		duplicateId: "This ID is already in the list",
		fetchError: "Error while fetching data:",
		placeholder: "Enter category ID",
		saveError: "Error while saving data:",
		saveSuccess: "Data saved successfully",
		saveSuccessMessage: "Data saved successfully!",
		stopList: "Stop list",
		tooltip: "Enter the category ID you want to hide",
	},
	blackList: {
		addDuplicate: "This number already exists",
		emptyValue: "Enter a value",
		menuTitle: "Menu",
		numbersTitle: "Numbers",
		phonePlaceholder: "Enter number",
		saveError: "Failed to update blacklist:",
		saveSuccessMessage: "Data saved successfully!",
		textPlaceholder: "Enter text to change",
		textTitle: "Blacklist text",
	},
	disableAlert: {
		messageStatus: "Message status",
		messageText: "Message text",
		placeholder: "Your text",
		switchLabel: "Enable message",
		updateError: "Error while updating data:",
	},
	disableApp: {
		messageText: "Message text",
		onApp: "Enable order acceptance",
		onDelivery: "Enable delivery",
		onPickup: "Enable pickup",
		placeholder: "Your text",
		title: "Order status",
	},
	delivery: {
		add: "Add",
		addZone: "Add zone",
		confirmCreateZone: "Do you confirm creating the zone?",
		confirmDeleteZone: "Do you confirm deleting zone {{name}}?",
		confirmEditZone: "Do you confirm editing the zone?",
		confirmSaveChanges: "Do you confirm saving the changes",
		deliveryCost: "Delivery cost",
		deliveryItemId: "Delivery item ID",
		editZone: "Edit zone",
		freeDelivery: "Free delivery",
		freeDeliveryFrom: "Free delivery from",
		minDeliveryAmount: "Minimum amount for delivery",
		noZones: "No zones created yet",
		title: "Delivery terms",
		zoneName: "Zone name",
		zones: "Zones",
		placeholders: {
			deliveryCost: "Enter delivery cost",
			deliveryItemId: "Enter delivery item ID",
			freeDeliveryFrom: "Enter minimum delivery amount",
			minDeliveryAmount: "Enter minimum order amount",
			zoneName: "Enter zone name",
		},
		validation: {
			deliveryCost: "Enter delivery cost",
			deliveryItemId: "Enter delivery item ID",
			freeDeliveryFrom: "Enter free delivery amount",
			minDeliveryAmount: "Enter order amount",
			zoneName: "Enter name",
		},
	},
	deliveryZonesControl: {
		enableZone: "Enable delivery in zone",
		error: "Something went wrong, please try again",
		minActiveZone: "At least one zone must be active",
		title: "Delivery zones control",
	},
	labels: {
		add: "Add",
		addLabel: "Add label",
		addNewLabel: "Add new label",
		addProductId: "Add product ID",
		backgroundColor: "Background color",
		banner: "Banner",
		bannerPreview: "Banner preview",
		bannerText: "Banner text",
		delete: "Delete",
		editLabel: "Edit label",
		imageReady: "Image is ready to upload",
		imageRequired: "Image is required",
		labels: "Labels",
		noLabels: "No labels available",
		noText: "No text",
		position: "Position",
		text: "Text",
		textColor: "Text color",
		textRequired: "Enter banner text",
		uploadBanner: "Banner upload",
		uploadImage: "Upload image",
		errors: {
			deleteImage: "Error while deleting image",
			fileTooLarge: "File is too large. Maximum size is 500KB.",
			imageName: "Error while getting image name from server",
			missingFileOrLogin: "file or login was not provided",
			unsupportedFormat: "Unsupported file format. Allowed: JPG, JPEG, PNG.",
			uploadImage: "Error while uploading image.",
		},
	},
	loadControl: {
		confirmSaveChanges: "Do you confirm saving the changes?",
		deliveryInterval: "Delivery time interval (min)",
		minNumber: "Enter a number greater than or equal to 5",
		pickupInterval: "Pickup time interval (min)",
		title: "Load control",
	},
	menu: {
		categories: "Categories",
		categoryIdPlaceholder: "Enter category ID",
		duplicateId: "This ID is already in the list",
		menu: "Menu",
		products: "Products",
		productIdPlaceholder: "Enter product ID",
		saveSuccess: "Data saved successfully!",
	},
	menuSort: {
		categories: "Categories",
		confirmSortChange: "Do you want to change product sorting?",
		copied: "Copied",
		copyId: "Copy ID",
		products: "Products",
		title: "Menu sorting",
	},
	payCard: {
		cardPaymentSystem: "Card payment system",
		confirmSaveChanges: "Do you confirm saving the changes?",
		title: "Payment systems",
		placeholders: {
			merchant: "Enter Merchant",
			merchantDomain: "Enter merchantDomain",
			merchantLogin: "Enter Merchant login",
			merchantSecretKey: "Enter Merchant secret key",
			mobileSdkKey: "Enter Mobile Sdk Key",
			payeeId: "Enter PayeeId",
			privateKey: "Enter Private key",
			publicKey: "Enter Public key",
			secretKey: "Enter Secret key",
			shopId: "Enter shop id",
			yandexMoney: "Enter Yandex Money",
		},
	},
	pickupControl: {
		enablePickupAt: "Enable pickup at",
		error: "Something went wrong, please try again",
		minActiveTerminal: "At least one terminal must be active",
		title: "Pickup points control",
	},
	products: {
		add: "Add",
		addCategory: "Add category",
		addProduct: "Add product",
		addProductFirst: "First add the product in {{language}}",
		category: "Category",
		chooseCategory: "Select category",
		chooseCity: "Select a city from the list",
		chooseTerminal: "Select venue",
		confirmSortChange: "Do you want to change product sorting?",
		copy: "Copy",
		copied: "Copied",
		copyCategoryId: "Copy category ID {{id}}",
		delete: "Delete",
		deleteCategoryConfirm: "Do you want to delete category {{name}}?",
		deleteCategoryProductsConfirm:
			"Deleting the category will delete all products! Delete?",
		deleteProductConfirm: "Do you want to delete product {{name}}?",
		description: "Description",
		display: "Display",
		differentPrices: "Different prices in venues",
		edit: "Edit",
		editCategory: "Edit category",
		errorTryAgain: "Error, please try again!",
		hide: "Hide",
		integerOnly: "Only integers are supported",
		maxPhotoSize: "Photo size must be no more than 0.5 MB",
		menuLanguage: "Menu language",
		name: "Name",
		nameField: "Name",
		newPhoto: "New photo",
		noCategories: "No categories yet",
		noDescription: "No description",
		noAccess: "You do not have access",
		photo: "Photo",
		price: "Price",
		saveError: "An error occurred, please try again",
		shop: "Venue:",
		showMore: "Show more",
		sortMode: "Sort mode",
		unsupportedImageFormat: "This image format is not supported",
	},
	promotion: {
		advertisingText:
			"In addition to promoting the app on your own website, you can share direct links to the app in your social media groups: Instagram, VK, Facebook.",
		advertisingTitle: "How else can you promote the app?",
		copy: "Copy",
		copied: "Text copied successfully!",
		downloadQr: "Download QR code",
		enableStoreBadges: "Enable AppStore & Google Play badges",
		insertCodeTitle: "Website embed code",
		qrDoorSize: "Entrance door - 20 cm on the long side.",
		qrMenuSize: "Menu cover - 5 cm on the long side.",
		qrParagraph1:
			"If a phone camera is pointed at the QR code, the system will suggest following the link and downloading the mobile app. This is the fastest way to find the app in the AppStore or Google Play.",
		qrParagraph2:
			"The sticker can be placed at the venue entrance, on the menu cover, on table stands, or in any other visible place. It looks modern and significantly increases app downloads.",
		qrParagraph3:
			"The downloadable format is suitable for any print shop or printing studio. Just send the link to the print shop and order the required number of stickers.",
		qrRecommendedSizes: "Recommended sizes:",
		qrStickerTitle: "QR code for sticker",
		scriptPlacement:
			"This script should be inserted into the website between the <head></head> tags.",
		scriptVisitors:
			"All website visitors will see that you now have a mobile app.",
		title: "Promotion",
	},
	push: {
		allUsers: "Send to all",
		audience: "Audience",
		city: "City",
		confirmSend: "Do you confirm sending the push notification?",
		favorite: "Selected",
		favorites: "Selected",
		hiddenText: "Hidden text",
		invalidPhone: "Invalid phone number",
		maxPhoneLength: "Maximum phone length is 14 digits, current is {{count}} digits",
		messagePlaceholder: "Enter message text",
		minPhoneLength: "Minimum phone length is 11 digits, current is {{count}} digits",
		phoneFormat: "Number format:",
		phonePlaceholder: "Phone number",
		phoneRequired: "Enter phone number",
		productLink: "With product link",
		productPlaceholder: "Enter product id",
		send: "Send",
		sendError: "An error occurred while sending, please try again!",
		sendSuccess: "Your notification has been sent successfully!",
		title: "Send Push notification",
		text: "Text",
		ukrainePhone: "Ukraine: 380501234567",
		russiaPhone: "Russia: 79201234567",
		usersHint:
			"Add phone numbers to send the notification to specific users, or leave the list empty if you want to send the push notification to all users.",
		usersList: "User list:",
		validation: {
			cityRequired: "City selection is required",
		},
		selectCity: "Select city",
	},
	reviews: {
		callCenter: "Call center work:",
		comment: "Comment:",
		date: "Date:",
		day: "Day",
		deliveryQuality: "Delivery quality:",
		highGrade: "Highest rating",
		impression: "Overall impression:",
		loadMore: "Show more",
		loadMoreDays: "Show 7 more days",
		lowGrade: "Lowest rating",
		month: "Month",
		newest: "Newest",
		noReviews: "You do not have any reviews yet!",
		oldest: "Oldest",
		period: "Period:",
		phone: "Phone number:",
		productQuality: "Product quality:",
		sort: "Sort",
		sortWithColon: "Sort:",
		title: "Reviews",
		week: "Week",
		impressions: {
			negative: "negative 🤬",
			neutral: "neutral 😐",
			positive: "positive 😍",
		},
	},
	workTime: {
		confirmSaveChanges: "Do you confirm saving the changes",
		deliveryInterval: "Delivery time interval (min)",
		infoMessage: "Information message",
		maxTime: "Maximum time",
		maxWorkTime: "Maximum venue working time",
		messagePlaceholder: "Enter text...",
		minEstablishment: "Minimum venue time",
		minTime: "Minimum time",
		pickupInterval: "Pickup time interval (min)",
		title: "Working hours",
	},
	defaultScreen: {
		logout: "Log out",
		navigation: {
			addProduct: "Add product",
			blacklist: "Blacklist",
			cardPayment: "Card payment",
			categories: "Categories",
			deliveryTerms: "Delivery terms",
			deliveryZones: "Delivery zones",
			disableOrders: "Disable orders",
			disablePickup: "Disable pickup",
			editProduct: "Edit product",
			labels: "Labels",
			leaveDescription: "Your data will not be saved.",
			leaveTitle: "Do you want to leave?",
			loadControl: "Load control",
			loginMessage: "Login message",
			loyaltySystem: "Loyalty system",
			menu: "Menu",
			menuFilling: "Menu filling",
			pickupCategories: "Pickup categories",
			products: "Products",
			promotion: "Promotion",
			push: "Push notification",
			reviews: "Reviews",
			settings: "Settings",
			sortMode: "Sort mode",
			stopList: "Stop list",
			stopListSorting: "Stop list/sorting",
			workingHours: "Working hours",
		},
	},
	language: {
		label: "Language",
		en: "Eng",
		ru: "Rus",
		uk: "Ukr",
	},
};

export default translation;
